import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IStore } from 'redux/IStore';
import { ManageShopWrapper } from 'containers';
import { PortalPageSection, PageTitle } from 'components/PortalStructure';
import { IProductsImportImagesData, IProductsImportImagesAction } from 'models/product/productsimportimages';
import { IProductsImportImage } from 'models/product/productsimportimage';
import { Spinner, SearchInput, Button } from 'components';
import {
	addSelectedImages,
	deleteImage,
	selectImage,
	selectAllImages,
	deleteSelectedImages,
	loadMore,
	setSearchKeyword,
	searchImages,
} from 'modules/product/productsimportimages';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { actions as notifActions } from 'redux-notifications';
const { notifSend } = notifActions;
const InfiniteScroll = require('react-infinite-scroll-component');
import Dropzone, { DropzoneProps, FileRejection } from 'react-dropzone';
import { imgSrcAttributes } from 'helpers/common';
const { connect } = require('react-redux');
require('./style.css');

interface IProps {
	params?: IParams;
	productsImportImages?: IProductsImportImagesData;
	dispatch?: any;

	/* functions props */
	t?: (key: string, object?: any) => string;
	addSelectedImages?: (filesToUpload: any, rejectedFiles: any) => IProductsImportImagesAction;
	deleteImage?: (id: string) => IProductsImportImagesAction;
	selectImage?: (id: string, select: boolean) => IProductsImportImagesAction;
	selectAllImages?: (select: boolean) => IProductsImportImagesAction;
	deleteSelectedImages?: () => IProductsImportImagesAction;
	loadMore?: () => IProductsImportImagesAction;
	setSearchKeyword?: (searchKeyword: string) => IProductsImportImagesAction;
	searchImages?: () => IProductsImportImagesAction;
}

interface IParams {
	id?: string;
}

@connect(
	(state: IStore) => ({
		productsImportImages: state.productsImportImages,
	}),
	(dispatch) => ({
		dispatch,
		addSelectedImages: (filesToUpload: any, rejectedFiles: any) =>
			dispatch(addSelectedImages(filesToUpload, rejectedFiles)),
		deleteImage: (id: string) => dispatch(deleteImage(id)),
		selectImage: (id: string, select: boolean) => dispatch(selectImage(id, select)),
		selectAllImages: (select: boolean) => dispatch(selectAllImages(select)),
		deleteSelectedImages: () => dispatch(deleteSelectedImages()),
		loadMore: () => dispatch(loadMore()),
		setSearchKeyword: (searchKeyword: string) => dispatch(setSearchKeyword(searchKeyword)),
		searchImages: () => dispatch(searchImages()),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ProductsImportImages extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.state = {
			disableUploadButton: false,
		};

		this.addSelectedFiles = this.addSelectedFiles.bind(this);
		this.deleteImage = this.deleteImage.bind(this);
		this.loadMore = this.loadMore.bind(this);
		this.handleSearchEnterPress = this.handleSearchEnterPress.bind(this);
		this.handleSearchValueChange = this.handleSearchValueChange.bind(this);
		this.onImageLinkCopy = this.onImageLinkCopy.bind(this);
	}

	private handleSearchEnterPress(event: any) {
		if (event.key === 'Enter') {
			this.props.searchImages();
		}
	}

	private handleSearchValueChange(e: any) {
		const value: string = e.target.value;
		this.props.setSearchKeyword(value.length > 0 ? value : '');
	}

	private addSelectedFiles(filesToUpload: File[], rejectedFiles: FileRejection[]) {
		this.props.addSelectedImages(filesToUpload, rejectedFiles);
	}

	private deleteImage(id: string) {
		this.props.deleteImage(id);
	}

	private loadMore() {
		this.props.loadMore();
	}

	private onImageLinkCopy() {
		this.props.dispatch(
			notifSend({
				message: this.props.t('Shop_ManageShop_Products_Import_Images_Message_LinkCopied'),
				kind: 'success',
				dismissAfter: 3000,
			}),
		);
	}

	public render() {
		const { params, t } = this.props;
		const { selectedImages, images, itemsPage, searchKeyword } = this.props.productsImportImages;

		let disableUploadButton: boolean = false;
		const imagesToUpload = images.filter((x) => x.isFetching === false && !x.uploaded && !x.error);
		if (imagesToUpload && imagesToUpload.length > 0) {
			disableUploadButton = true;
		}

		const dropZoneProps: DropzoneProps = {
			accept: 'image/jpeg, image/png, image/bmp, image/gif',
			multiple: true,
			maxSize: c.MAX_PRODUCT_IMAGE_SIZE,
			onDrop: (acceptedFiles, fileRejections) => {
				this.addSelectedFiles(acceptedFiles, fileRejections);
			},
		};

		const countOfItemsToDisplay =
			itemsPage.currentPage * itemsPage.itemsPerPage > itemsPage.totalItems
				? itemsPage.totalItems
				: itemsPage.currentPage * itemsPage.itemsPerPage;

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: countOfItemsToDisplay,
			next: this.loadMore,
			hasMore: itemsPage.totalItems > countOfItemsToDisplay,
			loader: itemsPage.totalItems > countOfItemsToDisplay ? <h2>{t('BSPortal_Common_Loading')}</h2> : null,
		};

		return (
			<ManageShopWrapper id={params.id}>
				<div className="productsImportImagesWrapper">
					<PageTitle
						title={t('Shop_ManageShop_Products_Import_Images_Label_Images')}
						titleContent={
							<Dropzone {...dropZoneProps}>
								{({ getRootProps, getInputProps }) => (
									<div {...getRootProps({ className: 'dropZoneButton' })}>
										<input {...getInputProps({ name: 'productsImportImagesFileUpload' })} />
										<Button type="button" disabled={disableUploadButton} size="medium">
											{t('Shop_ManageShop_Products_Import_Images_Label_UploadImages')}
										</Button>
									</div>
								)}
							</Dropzone>
						}
					/>
					<PortalPageSection>
						<div className="row">
							<div className="col-md-12">
								<SearchInput
									keyword={searchKeyword}
									onSearchEnterPress={this.handleSearchEnterPress}
									onSearchValueChange={this.handleSearchValueChange}
									placeholder={t('Shop_ManageShop_Products_Import_Images_Placeholder_SearchImages')}
								/>
							</div>
						</div>
					</PortalPageSection>
					<PortalPageSection>
						<div className="topMenuProducts">
							{selectedImages && selectedImages.length > 0 ? (
								<div className="selectedTop">
									<button className="selectedBtn" type="button">{`${selectedImages.length} Selected`}</button>
									<button
										className="closeBtn"
										type="button"
										onClick={() => {
											this.props.selectAllImages(false);
										}}
									>
										X
									</button>
									<button
										className="trashImg"
										type="button"
										onClick={() => {
											this.props.deleteSelectedImages();
										}}
									>
										<img src={require('containers/Html/icons/actionIcons/remove.svg')} />
									</button>
								</div>
							) : null}
							<div className="checkboxPosition">
								<div className="container">
									<input
										type="checkbox"
										onChange={(e: any) => {
											this.props.selectAllImages(e.target.checked);
										}}
										checked={itemsPage.items.length > 0 && itemsPage.items.length === selectedImages.length}
										className="rowCheckbox"
									/>
									<span className="checkmark" />
									<div className="checkboxArrow" />
								</div>
							</div>
							<div className="fonts title">{t('Shop_ManageShop_Products_Import_Images_Label_Title')}</div>
							<div className="fonts price">{t('Shop_ManageShop_Products_Import_Images_Label_Url')}</div>
							<div className="fonts modified">{t('Shop_ManageShop_Products_Import_Images_Label_Size')}</div>
							<div className="fonts quantity">{t('Shop_ManageShop_Products_Import_Images_Label_Status')}</div>
						</div>
						<InfiniteScroll {...infiniteScrollProps}>
							{itemsPage.items.slice(0, countOfItemsToDisplay).map((item: IProductsImportImage) => {
								let status: any = null;
								if ((!item.isFetching && !item.uploaded) || item.isFetching) {
									status = <Spinner />;
								}

								if (item.uploaded) {
									status = t('Shop_ManageShop_Products_Import_Images_Label_Uploaded');
								}

								if (item.error) {
									if (item.message.status) {
										status = t('Shop_ManageShop_Products_Import_Images_Label_Error') + ': ' + item.message.statusText;
									} else {
										status = t('Shop_ManageShop_Products_Import_Images_Label_Error') + ': ' + item.message.error;
									}
								}

								const imageIsChecked = selectedImages.find((x) => x === item.id) !== undefined ? true : false;

								return (
									<div key={item.id} className={`wrapperProduct ${imageIsChecked ? 'imgChecked' : ''}`}>
										<div className="checkboxPosition">
											<div className="container">
												<input
													type="checkbox"
													onChange={(e: any) => {
														this.props.selectImage(item.id, e.target.checked);
													}}
													checked={imageIsChecked}
													className="rowCheckbox"
												/>
												<span className="checkmark" />
											</div>
										</div>
										<div className="wrapperProductBorder">
											<div className="imageWrapper" style={{ display: 'inline-block' }}>
												{item.file.preview ? (
													<img {...imgSrcAttributes(item.file.preview)} style={{ width: '50px' }} />
												) : null}
											</div>
											<div className="name">
												<label>{item.file.name}</label>
											</div>
											<div className="price">
												<CopyToClipboard text={item.url} onCopy={this.onImageLinkCopy}>
													<label>{item.url}</label>
												</CopyToClipboard>
											</div>
											<div className="addedDate">
												<label>{(item.file.size / 1024).toFixed(2)} KB</label>
											</div>
											<div className="quantityText">{status}</div>
											<div className="deleteBtnPosition">
												<button
													type="button"
													onClick={() => {
														this.deleteImage(item.id);
													}}
												>
													<img src={require('containers/Html/icons/actionIcons/delete-img.png')} />
												</button>
											</div>
										</div>
									</div>
								);
							})}
						</InfiniteScroll>
					</PortalPageSection>
				</div>
			</ManageShopWrapper>
		);
	}
}

export { ProductsImportImages };
